import { h, Fragment } from "@stencil/core";
import { isDesktop, isDesktopLarge, ResizeListener, getTranslation, JsonParser, hasSlot, SlotChangeObserver } from "@ace/web-components/dist_lib/utils";
import { aceBettingSlipSlots, getAceBettingSlipNames } from "./ace-betting-slip.get-names";
const DEFAULT_TRANSLATIONS = {
    slip_label: 'Wettschein',
    my_bets_label: 'Meine Wetten',
    slip_single_label: 'Einzel',
    slip_combi_label: 'Kombi',
    slip_system_label: 'System',
    my_bets_open_bets_label: 'Offene Wetten',
    my_bets_cashout_bets_label: 'Cashout',
    my_bets_closed_bets_label: 'Beendet',
    cashout_filter_label: 'Cashout',
    close_label: 'Schließen',
    success_headline: 'Wette platziert',
    my_bets_link_label: 'Zu meinen Wetten',
    processing_message: 'Deine Wette wird platziert, dies kann bis zu 10 Sekunden dauern.',
};
export class AceBettingSlip {
    constructor() {
        this.selectedView = 'slip';
        this.selectedSlipFilter = 'single';
        this.selectedMyBetsFilter = 'open';
        this.cashoutFilterChecked = false; // TODO: Remove this prop once the cashout tab is fully launched.
        this.expandedOnMobile = false;
        this.showSuccessScreen = false;
        this.showBettingIsland = true;
        this.showNavButtons = true;
        this.showCashoutFilter = false; // TODO: Remove this prop once the cashout tab is fully launched.
        this.showCashoutTab = false;
        this.withCashoutTab = true; // TODO: Remove this prop once the cashout tab is fully launched.
        this.showQuoteAcceptanceModal = false;
        this.showSettingsButton = false;
        this.mobileVariant = 'default';
        this.processing = false;
        this.slipCount = 0;
        this.myBetsCount = 0;
        this.loggedIn = true;
        this.isDesktop = false;
        this.hasSlipHeaderSlotContent = false;
        this.hasSlipSlotContent = false;
        this.hasErrorToastSlotContent = false;
        // TODO: Remove this method once the cashout tab is fully launched.
        this.handleCashoutFilterChange = () => {
            this.cashoutFilterChecked = !this.cashoutFilterChecked;
            this.cashoutFilterChanged.emit({ checked: this.cashoutFilterChecked });
        };
        this.handleCloseSuccessScreen = () => {
            this.showSuccessScreen = false;
            this.successScreenClosed.emit();
        };
        this.handlePreferencesLinkClick = () => {
            this.showQuoteAcceptanceModal = true;
            this.quoteAcceptanceModalOpened.emit();
        };
        this.setSlipEntriesType = () => {
            if (this.slipSlotRef) {
                this.slipSlotRef.assignedNodes().forEach(node => {
                    node.setAttribute('type', this.selectedSlipFilter);
                });
            }
        };
        this.handleSlotChange = () => {
            this.hasSlipHeaderSlotContent = hasSlot(this.hostElement, aceBettingSlipSlots.SLIP_HEADER);
            this.hasSlipSlotContent = hasSlot(this.hostElement, aceBettingSlipSlots.SLIP);
            this.hasErrorToastSlotContent = hasSlot(this.hostElement, aceBettingSlipSlots.ERROR_TOAST);
        };
        this.calculateScreenSizes = ({ windowWidth }) => {
            this.isDesktop = isDesktop(windowWidth) || isDesktopLarge(windowWidth);
        };
        this.handleMobileNavClick = (view) => {
            if (!this.expandedOnMobile) {
                this.openBettingSlip(view);
            }
            else if (this.selectedView === view) {
                this.closeBettingSlip();
            }
            else {
                this.changeView(view);
            }
        };
    }
    componentWillLoad() {
        var _a;
        this.names = getAceBettingSlipNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
        ResizeListener.getInstance().subscribe(this.calculateScreenSizes);
        this.handleSlotChange();
        this.parseTranslations();
        this.observer = new SlotChangeObserver(this.hostElement, this.handleSlotChange.bind(this));
    }
    componentDidLoad() {
        this.setSlipEntriesType();
    }
    disconnectedCallback() {
        ResizeListener.getInstance().unsubscribe(this.calculateScreenSizes);
        this.observer.disconnect();
    }
    watchSlipCountProp() {
        var _a;
        // Animate the notification indicator when slip count changes.
        const notificationIndicator = (_a = this.hostElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.${this.names.CLASS.NOTIFICATION_INDICATOR}`);
        if (notificationIndicator) {
            // Remove and re-add animation class to trigger animation
            notificationIndicator.classList.remove(`${this.names.CLASS.NOTIFICATION_INDICATOR____CHANGE}`);
            setTimeout(() => {
                notificationIndicator.classList.add(`${this.names.CLASS.NOTIFICATION_INDICATOR____CHANGE}`);
            }, 5);
        }
    }
    handleNavChange() {
        if (this.selectedView === 'slip') {
            this.navSelected.emit({ view: 'slip', filter: this.selectedSlipFilter });
        }
        else if (this.selectedView === 'my-bets') {
            this.navSelected.emit({ view: 'my-bets', filter: this.selectedMyBetsFilter });
            // close success screen if it is open
            if (this.showSuccessScreen) {
                this.showSuccessScreen = false;
            }
        }
    }
    handleSlipFilterChange() {
        this.setSlipEntriesType();
    }
    parseTranslations() {
        this._translations = new JsonParser(this.translations, {}).getValue();
    }
    handleQuoteAcceptanceModalClose() {
        if (this.showQuoteAcceptanceModal) {
            this.showQuoteAcceptanceModal = false;
        }
    }
    openBettingSlip(view) {
        this.selectedView = view;
        this.expandedOnMobile = true;
    }
    closeBettingSlip() {
        this.expandedOnMobile = false;
    }
    changeView(view) {
        this.selectedView = view;
    }
    renderSlipButton() {
        return (h("ace-toggle-button", { id: 'bettingslip_button_slip', size: 'small', style: { '--ace-toggle-button-height': '2rem', '--ace-toggle-button-border-radius': '0.75rem' }, "full-width": 'true', class: this.names.CLASS.SLIP_BUTTON, active: this.selectedView === 'slip' && this.expandedOnMobile ? true : false, onClick: () => this.handleMobileNavClick('slip') }, getTranslation(this._translations, 'slip_label', DEFAULT_TRANSLATIONS), this.combinedOdds && ` • ${this.combinedOdds}`, this.slipCount > 0 && (h("ace-notification-indicator", { type: 'primary', class: this.names.CLASS.NOTIFICATION_INDICATOR }, this.slipCount))));
    }
    renderMyBetsButton() {
        return (h("ace-toggle-button", { id: 'bettingslip_button_mybets', style: { '--ace-toggle-button-height': '2rem', '--ace-toggle-button-border-radius': '0.75rem' }, size: 'small', "full-width": 'true', active: this.selectedView === 'my-bets' && this.expandedOnMobile ? true : false, onClick: () => this.handleMobileNavClick('my-bets') }, getTranslation(this._translations, 'my_bets_label', DEFAULT_TRANSLATIONS), this.myBetsCount > 0 && h("ace-notification-indicator", null, this.myBetsCount)));
    }
    renderBettingIsland() {
        // Render the buttons in the "Betting Island".
        const hasBets = this.slipCount > 0;
        const isAnchored = this.mobileVariant === 'anchored';
        let finalItems = [
            // Only show the Slip button if there are slips to show.
            ...(hasBets || isAnchored ? [this.renderSlipButton()] : []),
            ...(isAnchored ? [] : [this.renderMyBetsButton()]),
        ];
        let cssClasses = {
            [this.names.CLASS.ISLAND]: true,
            [this.names.CLASS.ISLAND____SINGLE_BUTTON]: !hasBets || isAnchored,
            [this.names.CLASS.ISLAND____ANCHORED]: isAnchored,
        };
        return (h("div", { class: cssClasses }, this.showBettingIsland && this.renderErrorToastSlot(), h("div", { class: this.names.CLASS.ISLAND__BUTTONS }, ...finalItems)));
    }
    renderMobileNav() {
        return (
        // Render the buttons in the footer slot of the expanded tray.
        h("div", { slot: 'footer', class: { [this.names.CLASS.MOBILE_NAV]: true, [this.names.CLASS.MOBILE_NAV____OPEN]: this.expandedOnMobile } }, this.renderSlipButton(), this.renderMyBetsButton()));
    }
    renderDesktopNav() {
        return (h("div", { class: this.names.CLASS.DESKTOP_NAV }, h("ace-segmented-controls", { onOptionSelected: event => this.changeView(event.detail), options: [
                { key: 'slip', label: getTranslation(this._translations, 'slip_label', DEFAULT_TRANSLATIONS), count: this.slipCount, notificationType: 'primary' },
                { key: 'my-bets', label: getTranslation(this._translations, 'my_bets_label', DEFAULT_TRANSLATIONS), count: this.myBetsCount },
            ], selected: this.selectedView })));
    }
    renderSlipView() {
        const renderCustomHeader = () => {
            return (h("div", { class: this.names.CLASS.SLIP_HEADER, slot: 'header' }, h("slot", { name: aceBettingSlipSlots.SLIP_HEADER })));
        };
        const renderSlipNav = () => {
            const tabItems = ['single', 'combi', 'system'].map(id => ({
                id,
                type: 'entry',
                name: getTranslation(this._translations, `slip_${id}_label`, DEFAULT_TRANSLATIONS),
                active: this.selectedSlipFilter === id,
            }));
            return (h("div", { class: this.names.CLASS.SUB_NAV, slot: 'header' }, h("ace-tabs", { onTabSelected: event => (this.selectedSlipFilter = event.detail), flex: true, "with-left-padding": 'false', items: tabItems }), this.showSettingsButton && (h("ace-button", { type: 'hidden', size: 'extra-small', "icon-name": 'settings', class: this.names.CLASS.PROFILE_BUTTON, onClick: this.handlePreferencesLinkClick }))));
        };
        const renderSlipHeader = () => {
            // if there is a custom header, render it
            if (this.hasSlipHeaderSlotContent) {
                return renderCustomHeader();
            }
            else if (this.slipCount > 0 && this.showNavButtons) {
                return renderSlipNav();
            }
            // if there is no custom header and no entries, render nothing
            return null;
        };
        const renderEmptySlip = () => {
            const classes = {
                [this.names.CLASS.CONTENT]: true,
                [this.names.CLASS.CONTENT____EMPTY]: true,
                [this.names.CLASS.SECTION]: true,
                [this.names.CLASS.SECTION____VISIBLE]: !this.hasSlipSlotContent,
            };
            return (h("div", { class: classes }, h("slot", { name: aceBettingSlipSlots.EMPTY_SLIP })));
        };
        const renderSlipContent = () => {
            const classes = {
                [this.names.CLASS.SECTION]: true,
                [this.names.CLASS.SECTION____SLIP_CONTENT]: true,
                [this.names.CLASS.SECTION____VISIBLE]: this.hasSlipSlotContent,
            };
            return (h("div", { class: classes }, h("div", { class: this.names.CLASS.CONTENT }, this.isDesktop || (!this.isDesktop && this.expandedOnMobile) ? this.renderErrorToastSlot() : null, h("slot", { name: aceBettingSlipSlots.SLIP, ref: el => (this.slipSlotRef = el) }), this.renderRemoveAllButton()), this.renderSummary()));
        };
        return (h(Fragment, null, this.selectedView === 'slip' && renderSlipHeader(), h("div", { class: { [this.names.CLASS.SECTION]: true, [this.names.CLASS.SECTION____VISIBLE]: this.selectedView === 'slip', [this.names.CLASS.SECTION____CONTENT]: true } }, renderEmptySlip(), renderSlipContent())));
    }
    renderErrorToastSlot() {
        if (!this.hasErrorToastSlotContent) {
            return;
        }
        return h("slot", { name: aceBettingSlipSlots.ERROR_TOAST });
    }
    renderMyBetsView() {
        const myBetsViewActive = this.selectedView === 'my-bets';
        const renderMyBetsHeader = () => {
            const renderMyBetsTabs = () => {
                // TODO: Remove the withCashoutTab check once the cashout tab is fully launched.
                const allTabItems = this.withCashoutTab && this.showCashoutTab ? ['open', 'cashout', 'closed'] : ['open', 'closed'];
                const tabItems = allTabItems.map(id => ({
                    id,
                    type: 'entry',
                    name: getTranslation(this._translations, `my_bets_${id}_bets_label`, DEFAULT_TRANSLATIONS),
                    active: this.selectedMyBetsFilter === id,
                }));
                return (h("ace-tabs", { onTabSelected: event => (this.selectedMyBetsFilter = event.detail), flex: true, slot: 'header', "with-left-padding": 'false', items: tabItems }));
            };
            // TODO: Remove this method once the cashout tab is fully launched.
            const renderCashoutFilter = () => (h("div", { class: this.names.CLASS.CASHOUT_FILTER }, h("ace-text", { weight: 'semibold', color: 'text-neutral--interactive', onClick: this.handleCashoutFilterChange }, getTranslation(this._translations, 'cashout_filter_label', DEFAULT_TRANSLATIONS)), h("ace-switch", { onChanged: this.handleCashoutFilterChange, checked: this.cashoutFilterChecked })));
            // Render tabs & cashout filter.
            return (h("div", { class: { [this.names.CLASS.SECTION]: true, [this.names.CLASS.SECTION____VISIBLE]: myBetsViewActive }, slot: 'header' }, renderMyBetsTabs(), this.selectedMyBetsFilter === 'open' && this.showCashoutFilter && !this.withCashoutTab && renderCashoutFilter()));
        };
        const renderMyBetsLink = () => {
            return (h("ace-button", { class: this.names.CLASS.FOOTER, type: 'tertiary', href: this.myBetsLink, "full-width": 'true' }, getTranslation(this._translations, 'my_bets_link_label', DEFAULT_TRANSLATIONS)));
        };
        const visibilityClasses = {
            [this.names.CLASS.SECTION]: true,
            [this.names.CLASS.SECTION____VISIBLE]: myBetsViewActive,
        };
        const sectionClasses = Object.assign(Object.assign({}, visibilityClasses), { [this.names.CLASS.SECTION____MY_BETS]: true });
        return [
            this.loggedIn && renderMyBetsHeader(),
            h("div", { class: sectionClasses }, h("div", { class: this.names.CLASS.CONTENT }, h("slot", { name: aceBettingSlipSlots.MY_BETS }))),
            this.loggedIn && this.myBetsLink && (h("div", { class: visibilityClasses, slot: 'footer' }, renderMyBetsLink())),
        ];
    }
    renderProcessingOverlay() {
        return (h("div", { class: this.names.CLASS.PROCESSING_OVERLAY }, h("ace-loader", { show: true, "force-mode": 'dark' }), h("ace-text", { color: 'text-neutral--primary-uni-light' }, getTranslation(this._translations, 'processing_message', DEFAULT_TRANSLATIONS))));
    }
    renderSuccessScreen() {
        return [
            h("div", { class: this.names.CLASS.CONTENT }, h("div", { class: this.names.CLASS.SUCCESS_HEADER }, h("ace-headline", { tag: 'h4' }, getTranslation(this._translations, 'success_headline', DEFAULT_TRANSLATIONS)), h("ace-button", { type: 'hidden', size: 'extra-small', "icon-name": 'close', onClick: this.handleCloseSuccessScreen })), h("slot", { name: aceBettingSlipSlots.SUCCESS })),
            h("div", { class: this.names.CLASS.FOOTER, slot: 'footer' }, h("ace-button", { type: 'primary', onClick: this.handleCloseSuccessScreen, "full-width": 'true' }, getTranslation(this._translations, 'close_label', DEFAULT_TRANSLATIONS))),
        ];
    }
    renderSummary() {
        const showSummary = this.selectedView === 'slip' && this.hasSlipSlotContent;
        let finalAttrs = {
            class: { [this.names.CLASS.SECTION]: true, [this.names.CLASS.SECTION____VISIBLE]: showSummary, [this.names.CLASS.SECTION____SUMMARY]: true },
        };
        return (h("div", Object.assign({}, finalAttrs), h("slot", { name: aceBettingSlipSlots.SUMMARY })));
    }
    renderContent() {
        if (this.showSuccessScreen) {
            return this.renderSuccessScreen();
        }
        return [this.renderSlipView(), this.renderMyBetsView()];
    }
    renderNumpad() {
        if (!hasSlot(this.hostElement, aceBettingSlipSlots.NUMPAD)) {
            return;
        }
        return h("slot", { name: aceBettingSlipSlots.NUMPAD, slot: 'footer' });
    }
    renderRemoveAllButton() {
        if (!hasSlot(this.hostElement, aceBettingSlipSlots.REMOVE_ALL)) {
            return;
        }
        return (h("div", { class: this.names.CLASS.REMOVE_ALL_BUTTON }, h("slot", { name: aceBettingSlipSlots.REMOVE_ALL })));
    }
    renderQuoteAcceptanceModal() {
        if (!hasSlot(this.hostElement, aceBettingSlipSlots.QUOTE_ACCEPTANCE_MODAL) || !this.showQuoteAcceptanceModal) {
            return;
        }
        return (
        // The slot footer positions the quote acceptance modal in the bottom tray, allowing it to expand fully.
        h("div", { class: this.names.CLASS.QUOTE_ACCEPTANCE_MODAL, slot: 'footer' }, h("slot", { name: aceBettingSlipSlots.QUOTE_ACCEPTANCE_MODAL })));
    }
    render() {
        const Tag = this.isDesktop ? 'div' : 'ace-betting-bottom-tray';
        // The betting slip is fully scrollable if:
        // - it's viewed on mobile OR tablet, for all filters (single, combi, system)
        // - it's system filter view (for all screen sizes)
        const isFullyScrollable = !this.isDesktop || (this.selectedSlipFilter === 'system' && this.selectedView === 'slip' && !this.showSuccessScreen);
        const tagAttrs = Object.assign(Object.assign(Object.assign({ id: this.names.ID.ROOT, class: {
                [this.names.CLASS.ROOT]: true,
                [this.names.CLASS.____FULLY_SCROLLABLE]: isFullyScrollable,
            } }, (Tag === 'ace-betting-bottom-tray' && { open: this.expandedOnMobile })), (Tag === 'ace-betting-bottom-tray' && { closeOnOverlayClick: !this.processing })), (Tag === 'ace-betting-bottom-tray' && {
            onBottomTrayClosed: () => {
                this.expandedOnMobile = false;
                this.selectedView = 'slip';
            },
        }));
        return (h(Fragment, { key: '5e12fbce8442462452c32d2fe789a49483c3312b' }, h(Tag, Object.assign({ key: 'abae175ea0a51b015b4622f9bba2bc83a799fca8' }, tagAttrs), this.processing && this.renderProcessingOverlay(), this.isDesktop && this.showNavButtons && this.renderDesktopNav(), this.renderContent(), this.renderNumpad(), this.renderQuoteAcceptanceModal(), !this.isDesktop && this.expandedOnMobile && this.showNavButtons && this.renderMobileNav()), !this.isDesktop && this.showBettingIsland && this.showNavButtons && this.renderBettingIsland()));
    }
    static get is() { return "ace-betting-slip"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-betting-slip.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-betting-slip.css"]
        };
    }
    static get properties() {
        return {
            "translations": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceBettingSlipTranslations | string",
                    "resolved": "IAceBettingSlipTranslations | string",
                    "references": {
                        "IAceBettingSlipTranslations": {
                            "location": "import",
                            "path": "./ace-betting-slip.types",
                            "id": "src/components/ace-betting-slip/ace-betting-slip.types.ts::IAceBettingSlipTranslations"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "translations",
                "reflect": false
            },
            "selectedView": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "IAceBettingSlipView",
                    "resolved": "\"my-bets\" | \"slip\"",
                    "references": {
                        "IAceBettingSlipView": {
                            "location": "import",
                            "path": "./ace-betting-slip.types",
                            "id": "src/components/ace-betting-slip/ace-betting-slip.types.ts::IAceBettingSlipView"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "selected-view",
                "reflect": true,
                "defaultValue": "'slip'"
            },
            "selectedSlipFilter": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "IAceBettingSlipFilter",
                    "resolved": "\"combi\" | \"single\" | \"system\"",
                    "references": {
                        "IAceBettingSlipFilter": {
                            "location": "import",
                            "path": "./ace-betting-slip.types",
                            "id": "src/components/ace-betting-slip/ace-betting-slip.types.ts::IAceBettingSlipFilter"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "selected-slip-filter",
                "reflect": true,
                "defaultValue": "'single'"
            },
            "selectedMyBetsFilter": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "IAceBettingSlipMyBetsFilterStatus",
                    "resolved": "\"cashout\" | \"closed\" | \"open\"",
                    "references": {
                        "IAceBettingSlipMyBetsFilterStatus": {
                            "location": "import",
                            "path": "./ace-betting-slip.types",
                            "id": "src/components/ace-betting-slip/ace-betting-slip.types.ts::IAceBettingSlipMyBetsFilterStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "selected-my-bets-filter",
                "reflect": true,
                "defaultValue": "'open'"
            },
            "cashoutFilterChecked": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "cashout-filter-checked",
                "reflect": true,
                "defaultValue": "false"
            },
            "expandedOnMobile": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "expanded-on-mobile",
                "reflect": true,
                "defaultValue": "false"
            },
            "showSuccessScreen": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "show-success-screen",
                "reflect": true,
                "defaultValue": "false"
            },
            "showBettingIsland": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "show-betting-island",
                "reflect": true,
                "defaultValue": "true"
            },
            "showNavButtons": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "show-nav-buttons",
                "reflect": true,
                "defaultValue": "true"
            },
            "showCashoutFilter": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "show-cashout-filter",
                "reflect": true,
                "defaultValue": "false"
            },
            "showCashoutTab": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "show-cashout-tab",
                "reflect": true,
                "defaultValue": "false"
            },
            "withCashoutTab": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "with-cashout-tab",
                "reflect": true,
                "defaultValue": "true"
            },
            "showQuoteAcceptanceModal": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "show-quote-acceptance-modal",
                "reflect": true,
                "defaultValue": "false"
            },
            "showSettingsButton": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "show-settings-button",
                "reflect": true,
                "defaultValue": "false"
            },
            "mobileVariant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceBettingSlipMobileVariant",
                    "resolved": "\"anchored\" | \"default\"",
                    "references": {
                        "IAceBettingSlipMobileVariant": {
                            "location": "import",
                            "path": "./ace-betting-slip.types",
                            "id": "src/components/ace-betting-slip/ace-betting-slip.types.ts::IAceBettingSlipMobileVariant"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "mobile-variant",
                "reflect": false,
                "defaultValue": "'default'"
            },
            "processing": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "processing",
                "reflect": false,
                "defaultValue": "false"
            },
            "myBetsLink": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "my-bets-link",
                "reflect": false
            },
            "slipCount": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "slip-count",
                "reflect": false,
                "defaultValue": "0"
            },
            "myBetsCount": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "my-bets-count",
                "reflect": false,
                "defaultValue": "0"
            },
            "combinedOdds": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "combined-odds",
                "reflect": false
            },
            "loggedIn": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "logged-in",
                "reflect": false,
                "defaultValue": "true"
            }
        };
    }
    static get states() {
        return {
            "isDesktop": {},
            "hasSlipHeaderSlotContent": {},
            "hasSlipSlotContent": {},
            "hasErrorToastSlotContent": {}
        };
    }
    static get events() {
        return [{
                "method": "navSelected",
                "name": "navSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "cashoutFilterChanged",
                "name": "cashoutFilterChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "successScreenClosed",
                "name": "successScreenClosed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "quoteAcceptanceModalOpened",
                "name": "quoteAcceptanceModalOpened",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "hostElement"; }
    static get watchers() {
        return [{
                "propName": "slipCount",
                "methodName": "watchSlipCountProp"
            }, {
                "propName": "selectedSlipFilter",
                "methodName": "handleNavChange"
            }, {
                "propName": "selectedMyBetsFilter",
                "methodName": "handleNavChange"
            }, {
                "propName": "selectedView",
                "methodName": "handleNavChange"
            }, {
                "propName": "selectedSlipFilter",
                "methodName": "handleSlipFilterChange"
            }, {
                "propName": "translations",
                "methodName": "parseTranslations"
            }];
    }
    static get listeners() {
        return [{
                "name": "bottomTrayClosed",
                "method": "handleQuoteAcceptanceModalClose",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "quoteChangeAccepted",
                "method": "handleQuoteAcceptanceModalClose",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=ace-betting-slip.js.map
